module.exports = __webpack_public_path__ + "static/img/9.4b20af5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/5/eng/9.png
// module id = J8TO
// module chunks = 0